<template>
  <div v-if="renderReady">
    <label :for="sid" class="label">
      {{ getTitle }}
      <!-- <w-tooltip :tooltip="tooltipContent"></w-tooltip> -->
    </label>

    <label :for="sid" class="select" v-bind:class="{ 'state-disabled': disabled }">
      <select
        class="form-control"
        ref="input"
        :value="svalue"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
      >
        <option v-if="placeholder" disabled="disabled" :selected="!svalue">{{ placeholder }}</option>
        <template v-for="(value, index) in values">
          <option v-if="!value.children" :key="index" :value="value.value">{{ value.text }}</option>
          <optgroup v-else :key="index" :label="value.text">
            <option v-for="(child, index2) in value.children" :value="child.value" :key="index2">{{ child.text }}</option>
          </optgroup>
        </template>
      </select>
      <i></i>
    </label>
    <w-error :model="model" @focus="$refs.input.focus()"></w-error>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"

import modelMixin from '@/mixins/modelMixin';
import WError from './error.vue';

export default {
  components: { WError },
  mixins: [modelMixin],
  props: {
    values: Array,
    placeholder: String
  },
  data() {
    return {
      sid: 'ddw' + Math.round(Math.random() * 1000000)
    };
  },
  methods: {
    textValue() {
      const ff = this.svalue;
      for (let i = 0; i < this.values.length; i++) {
        const vv = this.values[i];
        if (vv.children) {
          for (let j = 0; j < vv.children.length; j++) {
            if (vv.children[j].value === ff) {
              return vv.children[j].text;
            }
          }
        } else {
          if (vv.value === ff) {
            return vv.text;
          }
        }
      }
      return this.placeholder || '';
    }
  }
};
</script>
